const GOOGLE_CLIENT_ID = import.meta.env.VITE_GOOGLE_CLIENT_ID;
const GOOGLE_REDIRECT_URI = import.meta.env.DEV 
  ? 'http://localhost:5173'
  : window.location.origin;

export const googleAuthConfig = {
  client_id: GOOGLE_CLIENT_ID,
  redirect_uri: GOOGLE_REDIRECT_URI,
  scope: 'email profile',
  response_type: 'token',
  prompt: 'select_account',
  hd: 'tipit.cz', // Restrict to tipit.cz domain
};

export const buildGoogleAuthUrl = () => {
  const params = new URLSearchParams({
    ...googleAuthConfig,
    redirect_uri: GOOGLE_REDIRECT_URI,
  });
  
  return `https://accounts.google.com/o/oauth2/v2/auth?${params.toString()}`;
};